import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function AdminDeliverySalaryHistoryOnly() {
  const [deliveryBoys, setDeliveryBoys] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState("");
  const [deliveryIncome, setDeliveryIncome] = useState(0);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    axios.get("/admin/delivery-boys/").then(res => {
      setDeliveryBoys(res.data.delivery_boys || []);
    });
  }, []);

  useEffect(() => {
    if (!selectedBoy) return;

    // ✅ Lifetime delivery income
    axios
      .get(`/admin/delivery-income/?delivery_boy_id=${selectedBoy}`)
      .then(res => setDeliveryIncome(res.data.delivery_income || 0));

    // ✅ Monthly payout history
    axios
      .get(`/admin/delivery-salary-history/?delivery_boy_id=${selectedBoy}`)
      .then(res => setHistory(res.data.history || []));
  }, [selectedBoy]);

  return (
    <div style={{ padding: 24 }}>
      <h2>📜 Delivery Salary History</h2>

      <select
        value={selectedBoy}
        onChange={e => setSelectedBoy(e.target.value)}
        style={{ padding: 10, width: "100%", marginBottom: 16 }}
      >
        <option value="">Select Delivery Boy</option>
        {deliveryBoys.map(b => (
          <option key={b.id} value={b.id}>
            {b.name} ({b.phone})
          </option>
        ))}
      </select>

      <div style={{ marginBottom: 20 }}>
        <strong>Total Delivery Income:</strong> ₹{deliveryIncome}
      </div>

      {history.length === 0 ? (
        <p>No salary records found</p>
      ) : (
<table border="1" width="100%" cellPadding="8">
  <thead>
    <tr>
      <th>Month</th>
      <th>Delivery Income</th>
      <th>Salary</th>
      <th>Top-up</th>
      <th>Total Paid</th>
      <th>Note</th>
    </tr>
  </thead>

  <tbody>
    {history.map((h, i) => (
      <tr key={i}>
        <td>{h.month}</td>
        <td>₹{h.delivery_income}</td>
        <td>₹{h.salary_amount}</td>
        <td>₹{h.topup_amount}</td>
        <td>₹{h.total_paid}</td>
        <td>{h.admin_note || "—"}</td>
      </tr>
    ))}
  </tbody>
</table>

      )}
    </div>
  );
}
